import {ICasinofiedComponent} from './casinofied-component.interface';
import {IServiceFactoryExtended} from '../../../service-factory-extended.interface';
import {CasinofiedAppSdkLoader} from '../casinofied-app-sdk-loader';
import {IComponentController} from '@sparkware/uc-sdk-core';
import {action, observable} from 'mobx';

export abstract class CasinofiedComponentBase implements ICasinofiedComponent {
    protected readonly _containerID: string;

    constructor(protected readonly _componentID: string,
                private readonly _appSdkLoader: CasinofiedAppSdkLoader,
                protected readonly _services: IServiceFactoryExtended) {
        this._containerID = _services.tools.getGuid();
    }



    @observable.ref isLoading: boolean = false;
    @action.bound
    private _setIsLoading(value: boolean): void {
        this.isLoading = value;
    }
    async show(componentData: any): Promise<void> {
        this._setIsLoading(true);
        try {
            await this._appSdkLoader.loadAppSdk(this._componentID);
            this._displayComponent(componentData);
        } finally {
            this._setIsLoading(false);
        }
    }

    private _componentController(): IComponentController {
        const componentController: IComponentController = this._services.window.getGlobalProperty(this._componentID);

        if(!componentController) {
            throw new Error(`Couldn't find a controller for ${this._componentID} component`);
        }

        if(!componentController.show) {
            throw new Error(`${this._componentID} component doesn't implement show method`);
        }

        if(!componentController.remove) {
            throw new Error(`${this._componentID} component doesn't implement remove method`);
        }

        return componentController;
    }

    protected _displayComponent(componentData: any): void {
        this._componentController().show({
            containerID: this._containerID,
            messageBrokerChannels: this._services.messageBroker.channels,
            componentData: componentData
        });
    }

    remove() {
        this._componentController().remove();
    }
}
